import React from "react";
import "../post.css";
import DaySix from "../images/day_six.jpg";

export default class Post extends React.Component {
  render() {
    return (
      <div className="card">
        <h2 className="header">Day Six</h2>
        <img className="image" alt="itinerary" src={DaySix} />
        <div className="infobar">
          <div className="info">25 Nov 2018</div>
        </div>
        <h3>Morning</h3>
        <p>
          Arrive Osaka Station early in the morning. Get to the Airbnb by ride
          the train to Nippombashi Station. Walk along the Dotonbori River and
          find homestay. Check in and rest.
        </p>
        <h3>Evening</h3>
        <p>
          Get some Okonomiyaki for dinner along Dotonbori. Shinsaibashi is a
          shopping place to walk around after that.
        </p>
      </div>
    );
  }
}
